module.exports = __webpack_public_path__ + "img/ant-design_calendar-outlined.8b671670.svg";